<template>
    <div>
        <hr />
        <page :busy="busy" class="work-orders-manager-form-grid">
            <grid
                ref="grid"
                :columnDefs="columnDefs"
                :fetchCallback="fetchCallback"
            >
                <div class="work-orders-manager-form-grid__toolbar">
                    <responsive-button
                        :icon="['fas', 'arrows-rotate']"
                        @click="refresh"
                        variant="primary"
                        >Refresh</responsive-button
                    >
                    <responsive-button
                        :icon="['fas', 'plus']"
                        variant="primary"
                        @click="openAddNewModal"
                        >Add New Work Order</responsive-button
                    >
                </div>
            </grid>
        </page>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import API from '../../../api';
    import Grid from '../../generic/grid/grid.vue';
    import Page from '../../generic/page/page.vue';
    import Modal from '../../generic/modal/modal.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';

    export default {
        name: 'WorkOrdersManagerFormGrid',
        components: {
            Grid,
            Page,
            Modal,
            ResponsiveButton,
        },
        data() {
            return {
                offset: 0,
                limit: 20,
                sort: 'created',
                desc: false,
                search: '',
                busy: false,
                columnDefs: [
                    {
                        field: 'id',
                        headerName: 'ID',
                        maxWidth: 80,
                    },
                    {
                        field: 'status_name',
                        maxWidth: 100,
                        headerName: 'Status',
                        flex: 0,
                    },
                    {
                        field: 'priority_name',
                        maxWidth: 100,
                        headerName: 'Priority',
                        flex: 0,
                    },
                    {
                        field: 'property_name',
                        headerName: 'Property',
                        flex: 0,
                    },
                    {
                        field: 'reporter_name',
                        headerName: 'Reporter',
                        flex: 1,
                    },
                    {
                        field: 'description',
                        headerName: 'Description',
                        flex: 1,
                    },
                    {
                        field: 'vendor_team_member_name',
                        headerName: 'Vendor',
                        flex: 0,
                    },
                    {
                        field: 'who_will_pay',
                        headerName: 'Who Will Pay',
                        maxWidth: 120,
                    },
                    {
                        field: 'start_date',
                        headerName: 'Start Date',
                        maxWidth: 120,
                    },
                    {
                        field: 'date_reported',
                        headerName: 'Date Reported',
                        maxWidth: 120,
                    },
                    {
                        field: 'completed_date',
                        headerName: 'Date Completed',
                        maxWidth: 130,
                    },
                ],
            };
        },
        computed: {
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;

                    return API.get(`/app/work-orders/api/orders/grid`, {
                        params: {
                            vendor_pk: this.$route.params.id || '',
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                        },
                    });
                };
            },
        },
        methods: {
            openAddNewModal() {
                this.$router.push({
                    name: 'Work Order - List',
                    params: { fromVendorGrid: true },
                });
            },
            refresh() {
                this.$refs.grid.refreshDataSource();
            },
        },
    };
</script>

<style scoped lang="scss">
    .work-orders-manager-form-grid {
        height: 30rem !important;
    }

    hr {
        margin: 1rem 1rem 2rem 1rem !important;
        border-top: 1px solid rgba(224, 224, 224, 0.97);
    }
</style>
